import { AxiosInstance } from 'axios'

import { API_IDENTITY_VERIFICATION_INITIATE, API_IDENTITY_VERIFICATION_STATUS } from './url'

import { buildApiEndpoint, createSolarApiClient } from '@/shared/libs/api-client'

import type {
  IdentityVerificationInitiateData,
  IdentityVerificationStatusData,
  IdentityVerification,
  IdentityVerificationRedirectUri,
} from './types'

export class IdentityVerificationService {
  constructor(private readonly apiClient: AxiosInstance) {}

  /**
   * 본인인증 시작
   * POST /identity-verification/{provider}/initiate
   * @param provider - 'phone' (NICE) 또는 'toss'
   * @body redirectUris - 성공/실패 시 리다이렉트될 URI
   */
  async initiate(
    provider: IdentityVerification,
    redirectUri: IdentityVerificationRedirectUri,
  ): Promise<IdentityVerificationInitiateData> {
    const config = buildApiEndpoint(
      {
        method: 'POST',
        url: API_IDENTITY_VERIFICATION_INITIATE(provider),
        headers: {
          deviceType: 'BROWSER',
        },
        data: {
          redirectUri,
        },
      },
      'solar',
    )
    const response = await this.apiClient.request<IdentityVerificationInitiateData>(config)
    return response.data
  }

  /**
   * 사용자의 본인인증 여부 조회
   * GET /account/user/identity-verification
   */
  async getVerificationStatus(): Promise<IdentityVerificationStatusData> {
    const config = buildApiEndpoint(
      {
        method: 'GET',
        url: API_IDENTITY_VERIFICATION_STATUS,
        headers: {
          deviceType: 'BROWSER',
        },
      },
      'solar',
    )
    const response = await this.apiClient.request<IdentityVerificationStatusData>(config)
    return response.data
  }
}

// 클라이언트 사이드용 인스턴스
export const clientIdentityVerificationService = new IdentityVerificationService(createSolarApiClient())
